import React from 'react';
import ReactDOM from 'react-dom/client';
import tab_icon from './assets/tab-icon.png';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function set_tab_icon(href) {
  for (const rel of ['icon', 'apple-touch-icon']) {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
    if (rel === 'icon') link.type = 'image/png';
  }
}

set_tab_icon(tab_icon);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
